import React from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Styles
import './Spinner.scss';

const Spinner: React.FC = () => (
    <Grid
        container
        item
        xs={12}
        justify="center"
        className="ui-Spinner-container"
    >
        <div
            className="loadingio-spinner-spinner-v1ow1wp3ex"
        >
            <div
                className="ldio-teltvz8g6j9"
            >
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    </Grid>
);

export default Spinner;
